import { TableCategory, TableHeaders } from '@/shared/components/table/models';
import { boolToYN } from '@/utils/boolToYN';

export const Categories1TableHeaders: TableHeaders[] = [
  { key: 'number', label: 'NO', tdClass: 'min-w-50' },
  {
    key: 'category',
    label: 'Category'
  },
  {
    key: 'date',
    label: 'Date'
  },
  {
    key: 'orderNumber',
    label: 'WO #'
  },
  {
    key: 'billTo',
    label: 'Bill To'
  }
];

export const EquipmentTableHeaders = [
  {
    key: 'containerNumber',
    label: 'Cont #'
  },
  {
    key: 'shippingLine',
    rendererKey: 'equipment',
    label: 'SSL',
    collapsed: true
  },
  {
    key: 'containerSize',
    rendererKey: 'equipment',
    label: 'SZ',
    collapsed: true
  },
  {
    key: 'chassisNumber',
    rendererKey: 'equipment',
    label: 'CHASSIS #',
    collapsed: true
  },
  {
    key: 'chassisPool',
    rendererKey: 'equipment',
    label: 'POOL',
    collapsed: true
  },
  {
    key: 'bondEntry',
    rendererKey: 'equipment',
    label: 'Bond',
    collapsed: true
  }
];

export const InfoTableHeaders: TableHeaders[] = [
  {
    key: 'masterBillOfLading',
    label: 'M B/L'
  },
  {
    key: 'referenceNumber',
    label: 'REF',
    rendererKey: 'info',
    collapsed: true
  },
  {
    key: 'poNumber',
    rendererKey: 'info',
    label: 'PO',
    collapsed: true
  },
  {
    key: 'weight',
    rendererKey: 'info',
    label: 'WGT',
    collapsed: true
  },
  {
    key: 'quantity',
    rendererKey: 'info',
    label: 'QTY',
    collapsed: true
  },
  {
    key: 'overHeight',
    rendererKey: 'info',
    label: 'OH',
    formatter: boolToYN,
    collapsed: true
  },
  {
    key: 'overWeight',
    rendererKey: 'info',
    label: 'OW',
    formatter: boolToYN,
    collapsed: true
  },
  {
    key: 'haz',
    rendererKey: 'info',
    label: 'HAZ',
    formatter: boolToYN,
    collapsed: true
  },
  {
    key: 'hot',
    rendererKey: 'info',
    label: 'HOT',
    formatter: boolToYN,
    collapsed: true
  }
];

export const Categories2TableHeaders: TableHeaders[] = [
  {
    key: 'eta',
    label: 'ETA'
  },
  {
    key: 'lastFreeDay',
    label: 'LFD'
  },
  {
    key: 'avaDate',
    label: 'AVD'
  },
  {
    key: 'streetTurn',
    label: 'S/T'
  },
  {
    key: 'returnFreeDay',
    label: 'RFD'
  }
];

export const POutTableHeaders: TableHeaders[] = [
  {
    key: 'pulloutLocation',
    label: 'P/OUT',
    tdClass: 'min-w-130'
  },
  {
    key: 'pulloutSchedule',
    rendererKey: 'pOut',
    label: 'S IN',
    tdClass: 'min-w-130'
  },
  {
    key: 'pulloutActualIn',
    rendererKey: 'pOut',
    label: 'A IN',
    tdClass: 'min-w-130'
  },
  {
    key: 'pulloutActualOut',
    rendererKey: 'pOut',
    label: 'A OUT',
    tdClass: 'min-w-130'
  },
  {
    key: 'pulloutDriver',
    rendererKey: 'pOut',
    label: 'DRV',
    tdClass: 'min-w-130'
  }
];

export const DilvTableHeaders: TableHeaders[] = [
  {
    key: 'deliveryLocation',
    label: 'DILV',
    tdClass: 'min-w-130'
  },
  {
    key: 'deliverySchedule',
    rendererKey: 'dilv',
    label: 'S IN',
    tdClass: 'min-w-130'
  },
  {
    key: 'deliveryActualIn',
    rendererKey: 'dilv',
    label: 'A IN',
    tdClass: 'min-w-130'
  },
  {
    key: 'deliveryActualOut',
    rendererKey: 'dilv',
    label: 'A OUT',
    tdClass: 'min-w-130'
  },
  {
    key: 'deliveryDriver',
    rendererKey: 'dilv',
    label: 'DRV',
    tdClass: 'min-w-130'
  }
];

export const PUTableHeaders: TableHeaders[] = [
  {
    key: 'pickupLocation',
    label: 'P/U',
    tdClass: 'min-w-130'
  },
  {
    key: 'emptyConfirmation',
    rendererKey: 'pU',
    label: 'Empty CFM',
    tdClass: 'min-w-130'
  },
  {
    key: 'pickupSchedule',
    rendererKey: 'pU',
    label: 'S IN',
    tdClass: 'min-w-130'
  },
  {
    key: 'pickupActualIn',
    rendererKey: 'pU',
    label: 'A IN',
    tdClass: 'min-w-130'
  },
  {
    key: 'pickupActualOut',
    rendererKey: 'pU',
    label: 'A OUT',
    tdClass: 'min-w-130'
  },
  {
    key: 'pickupDriver',
    rendererKey: 'pU',
    label: 'DRV',
    tdClass: 'min-w-130'
  }
];

export const RtnTableHeaders: TableHeaders[] = [
  {
    key: 'returnLocation',
    label: 'RTN',
    tdClass: 'min-w-130'
  },
  {
    key: 'returnSchedule',
    rendererKey: 'rtn',
    label: 'S IN',
    tdClass: 'min-w-130'
  },
  {
    key: 'returnActualIn',
    rendererKey: 'rtn',
    label: 'A IN',
    tdClass: 'min-w-130'
  },
  {
    key: 'returnActualOut',
    rendererKey: 'rtn',
    label: 'A OUT',
    tdClass: 'min-w-130'
  },
  {
    key: 'returnDriver',
    rendererKey: 'rtn',
    label: 'DRV',
    tdClass: 'min-w-130'
  }
];

export const ArTableHeaders: TableHeaders[] = [
  {
    key: 'ar',
    label: 'A/R'
  },
  {
    key: 'arTruckingCharges',
    rendererKey: 'ar',
    label: 'Trucking'
  },
  {
    key: 'arFuelSurCharges',
    rendererKey: 'ar',
    label: 'FSC/R'
  },
  {
    key: 'arChassis',
    rendererKey: 'ar',
    label: 'CH/R'
  },
  {
    key: 'arPerdiem',
    rendererKey: 'ar',
    label: 'PE/R'
  },
  {
    key: 'arDemurrage',
    rendererKey: 'ar',
    label: 'DE/R'
  },
  {
    key: 'arDryRun',
    rendererKey: 'ar',
    label: 'DR/R'
  }
];

export const ApTableHeaders: TableHeaders[] = [
  {
    key: 'apPerdiem',
    label: 'A/P'
  },
  {
    key: 'apDryRun',
    rendererKey: 'ap',
    label: 'DRV/P'
  },
  {
    key: 'apChassisFees',
    rendererKey: 'ap',
    label: 'CH/P'
  },
  {
    key: 'apPerdiem1',
    rendererKey: 'ap',
    label: 'PE/P'
  },
  {
    key: 'apDemurrage',
    rendererKey: 'ap',
    label: 'DE/P'
  },
  {
    key: 'apDriverPay',
    rendererKey: 'ap',
    label: 'DR/P'
  }
];

export const Categories3TableHeaders: TableHeaders[] = [
  {
    key: 'profit',
    label: 'Prft'
  },
  {
    key: 'inv',
    label: 'INV'
  }
];

export const DocumentTableHeaders: TableHeaders[] = [
  {
    key: 'filePod',
    label: 'POD',
    formatter: boolToYN
  },
  {
    key: 'fileBl',
    rendererKey: 'document',
    label: 'B/L',
    formatter: boolToYN
  },
  {
    key: 'fileDo',
    rendererKey: 'document',
    label: 'DO',
    formatter: boolToYN
  },
  {
    key: 'fileIt',
    rendererKey: 'document',
    label: 'IT',
    formatter: boolToYN
  }
];

export const Categories4TableHeaders: TableHeaders[] = [
  {
    key: 'remarks',
    label: 'Remark'
  }
];

export const ImportRegularCategoriesHeaders: TableCategory[] = [
  {
    key: 'category1',
    label: ' ',
    maxColspan: Categories1TableHeaders.length,
    minColspan: 1
  },
  {
    key: 'equipment',
    label: 'EQUIPMENT',
    maxColspan: EquipmentTableHeaders.length,
    minColspan: 1,
    class: 'equipment-color',
    collapsed: true,
    opportunityСhange: true
  },
  {
    key: 'info',
    label: 'INFO',
    maxColspan: InfoTableHeaders.length,
    minColspan: 1,
    class: 'info-color',
    collapsed: true,
    opportunityСhange: true
  },
  {
    key: 'category2',
    label: '',
    maxColspan: Categories2TableHeaders.length,
    minColspan: 1
  },
  {
    key: 'pOut',
    label: 'P/OUT Dispatching',
    maxColspan: POutTableHeaders.length,
    minColspan: 1,
    class: 'p-out-color',

    opportunityСhange: true
  },
  {
    key: 'dilv',
    label: 'DILV Dispatching',
    maxColspan: DilvTableHeaders.length,
    minColspan: 1,
    class: 'dilv-color',

    opportunityСhange: true
  },
  {
    key: 'pU',
    label: 'P/U Dispatching',
    maxColspan: PUTableHeaders.length,
    minColspan: 1,
    class: 'p-u-color',

    opportunityСhange: true
  },
  {
    key: 'rtn',
    label: 'RTN Dispatching',
    maxColspan: RtnTableHeaders.length,
    minColspan: 1,
    class: 'rtn-color',

    opportunityСhange: true
  },
  {
    key: 'ar',
    label: 'AR',
    maxColspan: ArTableHeaders.length,
    minColspan: 1,
    class: 'ar-color',

    opportunityСhange: true
  },
  {
    key: 'ap',
    label: 'AP',
    maxColspan: ApTableHeaders.length,
    minColspan: 1,
    class: 'ap-color',

    opportunityСhange: true
  },
  {
    key: 'category3',
    label: '',
    maxColspan: Categories3TableHeaders.length,
    minColspan: 1
  },
  {
    key: 'document',
    label: 'Document',
    maxColspan: DocumentTableHeaders.length,
    minColspan: 1,
    class: 'document-color',

    opportunityСhange: true
  },
  {
    key: 'category4',
    label: '',
    maxColspan: Categories4TableHeaders.length,
    minColspan: 1
  }
];

export const ImportRegularTableHeaders: TableHeaders[] = [
  ...Categories1TableHeaders,
  ...EquipmentTableHeaders,
  ...InfoTableHeaders,
  ...Categories2TableHeaders,
  ...POutTableHeaders,
  ...DilvTableHeaders,
  ...PUTableHeaders,
  ...RtnTableHeaders,
  ...ArTableHeaders,
  ...ApTableHeaders,
  ...Categories3TableHeaders,
  ...DocumentTableHeaders,
  ...Categories4TableHeaders
];
